import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import styled from 'styled-components';
import Image from '@nubank/nuds-web/components/Image/Image';
import Button from '@nubank/nuds-web/components/Button/Button';

import ImagePreload from '@nubank/www-latam-commons/components/ImagePreload/ImagePreload';

import FormBox from '../../../../components/FormBox/FormBox';

const HERO_IMAGES = {
  xs: 'faq/hero-xs.jpg',
  lg: 'faq/hero-lg.jpg',
};

const StyledTypography = styled(Typography)`
  /* stylelint-disable color-function-notation */
  background: linear-gradient(180deg, rgb(159.46, 45.01, 234.81) 0%, rgb(98, 0, 163) 100%);
  /* stylelint-disable property-no-vendor-prefix, property-no-unknown */
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
  height: 100%;

  @media (width >= 1151px) {
    font-size: 3.5rem;
  }
`;

const StyledCTA = styled(Box)`
  position: absolute;
  bottom: 40px;
  left: 48%;
  transform: translateX(-50%);
  z-index: 1;
  width: 280px;

  @media (width >= 768px) {
    display: none ;
  }
`;

const StyledButton = styled(Button)`
  position: absolute;
  bottom: -24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
`;

const StyledImage = styled(Image)`
  height: 60vh;
  object-fit: cover;
  border-radius: 12px;
  
  @media (width >= 1151px) {
    height: 420px;
    max-width: 1580px;
    margin: 0 auto;
  }
`;

const Hero = () => {
  const scrollDown = () => {
    const element = document.getElementById('search-section');

    if (element) {
      const elementHeight = element.clientHeight;
      const windowHeight = window.innerHeight;
      const scrollPosition = element.offsetTop - (windowHeight - elementHeight) / 2;

      window.scrollTo({
        top: scrollPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    <>
      <ImagePreload srcSet={HERO_IMAGES} />
      <Box
        tag="section"
        height="100%"
        marginVertical={{ xs: '16px', lg: '67px' }}
        paddingHorizontal={{ xs: '1.5rem', md: '3.5rem' }}

      >
        <StyledTypography
          intlKey="FAQ.HOME_PAGE.TITLE"
          color="primary"
          variant="heading2"
          textAlign="center"
          whiteSpace={{ xs: 'pre-line', lg: 'nowrap' }}
          paddingTop={{ xs: '21px', lg: '0' }}
        />

        <Box
          marginVertical={{ xs: '48px', lg: '80px' }}
          position="relative"
          maxWidth={{ xs: '489px', lg: '1580px' }}
          margin="0 auto"
        >
          <StyledImage
            srcSet={HERO_IMAGES}
            alt="Una persona sonrie mientras sostiene su telefono morado en la mano"
          />
          <StyledCTA>
            <FormBox ctaHide />
          </StyledCTA>
          <StyledButton
            variant="contained"
            iconProps={{ name: 'arrow-down', title: 'Bajar a siguiente sección' }}
            onClick={scrollDown}
          />
        </Box>
      </Box>
    </>
  );
};

export default Hero;
